<template>
  <div v-if="showBusinessHours" class="attribute">
    <p class="label">営業時間</p>
    <div class="value">
      <div v-if="is24Hours">24時間営業</div>
      <div v-else>
        <div v-if="weekdayHours">平日： {{ weekdayHours }}</div>
        <div v-if="saturdayHours">土曜： {{ saturdayHours }}</div>
        <div v-if="sundayHours">日曜： {{ sundayHours }}</div>
        <div v-if="holidayHours">祝日： {{ holidayHours }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * 店舗ページに表示する営業時間
 */

const props = defineProps({
  point: {
    type: Object, // Point
    required: true,
  },
});

/**
 * 24時間営業かどうか
 * true: 24時間営業
 */
const is24Hours = props.point.extra_fields['24時間営業'] === '1'

/**
 * 平日の営業時間
 */
const weekdayHours = props.point.extra_fields['営業時間(平日)']

/**
 * 土曜日の営業時間
 */
const saturdayHours = props.point.extra_fields['営業時間(土曜日)']

/**
 * 日曜日の営業時間
 */
const sundayHours = props.point.extra_fields['営業時間(日曜日)']

/**
 * 祝日の営業時間
 */
const holidayHours = props.point.extra_fields['営業時間(祝日)']

/**
 * 営業時間を表示する
 * true: 表示
 */
const showBusinessHours = is24Hours || weekdayHours || saturdayHours || sundayHours || holidayHours
</script>
